import React from 'react';
import PropTypes from 'prop-types';

// Fundo e bullet pedidos pelo usuário para verde/creme/vermelho (badge suave, texto neutro
// escuro igual em todas as cores — só o fundo e o bullet mudam por tom).
const TONES = {
  green: { bg: '#F1FBED', color: '#1B1B1B', dot: 'rgba(41, 129, 30, 0.7)' },
  blue: { bg: 'rgb(242, 248, 255)', color: '#1B1B1B', dot: 'rgba(31, 116, 179, 0.7)' },
  purple: { bg: '#faf5ff', color: '#1B1B1B', dot: '#a855f7' },
  orange: { bg: '#FFF6E5', color: '#1B1B1B', dot: 'rgba(237, 94, 42, 0.7)' },
  red: { bg: '#FFF5F3', color: '#1B1B1B', dot: 'rgb(212, 45, 53)' },
  grey: { bg: '#f4f4f5', color: '#1B1B1B', dot: '#a1a1aa' },
};

// Mapeia valores comuns de vínculo empregatício para uma cor consistente.
// Qualquer valor não mapeado cai no cinza neutro (fallback seguro para dados vindos do banco).
const VINCULO_TONE = {
  clt: 'blue',
  pj: 'purple',
  estagio: 'orange',
  'estágio': 'orange',
  terceirizado: 'grey',
  temporario: 'grey',
  'temporário': 'grey',
  autonomo: 'grey',
  'autônomo': 'grey',
};

export const toneForVinculo = (value) => VINCULO_TONE[String(value).trim().toLowerCase()] || 'grey';

// Badge/chip curto para valores categóricos (tipo de vínculo, status, etc.).
// O bullet é pra estado que muda sozinho (ex.: Ativo/Desligado) — categoria fixa
// (ex.: Tipo de Vínculo) usa dot={false} pra não passar a ideia de "status ao vivo".
// Uso: <Tag tone="blue" dot={false}>CLT</Tag> ou <Tag tone={toneForVinculo(value)}>{value}</Tag>
const Tag = ({ children, tone, dot: showDot }) => {
  const { bg, color, dot } = TONES[tone] || TONES.grey;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 10px',
        borderRadius: 999,
        fontSize: '0.85em',
        fontWeight: 500,
        lineHeight: 1.2,
        backgroundColor: bg,
        color,
        whiteSpace: 'nowrap',
      }}
    >
      {showDot && (
        <span
          style={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: dot,
            flexShrink: 0,
          }}
        />
      )}
      {children}
    </span>
  );
};

Tag.propTypes = {
  children: PropTypes.node,
  tone: PropTypes.oneOf(['green', 'blue', 'purple', 'orange', 'red', 'grey']),
  dot: PropTypes.bool,
};

Tag.defaultProps = {
  tone: 'grey',
  dot: true,
};

export default Tag;
